import type IProduct from 'interfaces/IProduct';

export type Prices = Array<{
  value: number;
  currency_code: string;
  membership_value: number;
}>;

export type FormValues = {
  recurring_frequency: number;
  recurring_frequency_type: FrequencyType;
  recurring_frequency_type_select: CustomFrequencyType;
  yearly_installment: boolean;
  membership_fee: boolean;
  membership_price: number;
  remove_access: boolean;
  trial: boolean;
  undetermined_charges: string;
  overdue_limit: number;
  limit_charges: number;
  trial_days: number;
  plan_title: string;
  plan_description: string;
  is_visible_affiliate: boolean;
  prices: Prices;
};

export type FormProps = {
  product: Partial<IProduct>;
  handleClose: () => void;
  updateProduct: (product: Partial<IProduct>) => void;
};

export enum FrequencyType {
  MENSAL = 'M',
  TRIMESTRAL = 'TM',
  SEMESTRAL = 'SM',
  ANUAL = 'Y',
  PERSONALIZADO = 'P',
}

export enum CustomFrequencyType {
  MES = 'MONTH',
  ANO = 'YEAR',
}

export enum TypeCharge {
  INFINITA = 'infinite',
  FINITA = 'finite',
}

export const frequencyOptions = [
  {
    label: 'Mensal',
    value: FrequencyType.MENSAL,
  },
  {
    label: 'Trimestral',
    value: FrequencyType.TRIMESTRAL,
  },
  {
    label: 'Semestral',
    value: FrequencyType.SEMESTRAL,
  },
  {
    label: 'Anual',
    value: FrequencyType.ANUAL,
  },
  {
    label: 'Personalizado',
    value: FrequencyType.PERSONALIZADO,
  },
];

export const initialValues: FormValues = {
  recurring_frequency: 1,
  recurring_frequency_type: FrequencyType.MENSAL,
  recurring_frequency_type_select: CustomFrequencyType.MES,
  yearly_installment: false,
  membership_fee: false,
  membership_price: 0,
  remove_access: false,
  trial: false,
  undetermined_charges: 'false',
  overdue_limit: 5,
  limit_charges: 2,
  trial_days: 2,
  plan_title: '',
  plan_description: '',
  is_visible_affiliate: false,
  prices: [{ value: 0, currency_code: 'BRL', membership_value: 0 }],
};
